// eslint-disable-next-line no-unused-vars
import { IEngagementAttachment } from 'pages/WirelineEngagements/WirelineEngagements.models';
import {
  clearErrorsAttachments,
} from 'pages/WirelineEngagements/WirelineEngagementsAttachments/ClearErrorsAttachments/actionCreators';

const clearAttachmentsErrorsAction = (
  attachments: IEngagementAttachment[],
) => async (dispatch) => {
  dispatch(clearErrorsAttachments(attachments));
};

export default clearAttachmentsErrorsAction;
